import { render } from "./DatiUtente.vue?vue&type=template&id=672d1ef5"
import script from "./DatiUtente.vue?vue&type=script&lang=js"
export * from "./DatiUtente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__